import { ShieldCheck, RefreshCw, KeyRound, HeadphonesIcon } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

export default function Guarantees({ networkName, accentColor }) {
  const { t } = useLanguage();
  const items = [
    { icon: RefreshCw, title: t("network.guarantee_replacement", "Remplacement garanti"), desc: t("network.guarantee_replacement_desc", "En cas de baisse constatée, nous complétons automatiquement.") },
    { icon: KeyRound, title: t("trust.no_password", "Aucun mot de passe demandé"), desc: t("network.guarantee_no_password_desc", "Uniquement votre nom d'utilisateur ou l'URL de votre publication.") },
    { icon: ShieldCheck, title: t("trust.secure_payment", "Paiement sécurisé"), desc: t("network.guarantee_payment_desc", "Carte bancaire, Apple Pay, Google Pay via Mollie.") },
    { icon: HeadphonesIcon, title: t("network.guarantee_support", "Support francophone"), desc: t("network.guarantee_support_desc", "Une équipe disponible 7j/7 pour votre commande.") },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="network-guarantees">
      {items.map((it) => (
        <div key={it.title} className="rounded-2xl border border-white/8 bg-zinc-900/60 p-5 text-center" data-testid={`guarantee-${it.title}`}>
          <div className="w-11 h-11 rounded-xl flex items-center justify-center mx-auto mb-3" style={{ background: `${accentColor}1a` }}>
            <it.icon className="w-5 h-5" style={{ color: accentColor }} />
          </div>
          <h3 className="font-heading text-sm font-semibold mb-1">{it.title}</h3>
          <p className="text-xs text-zinc-500">{it.desc}</p>
        </div>
      ))}
    </div>
  );
}
